import React from 'react';
import { Users, UserCheck, Database, Smartphone, Ship, Building, ArrowUpRight } from 'lucide-react';
import { services } from '../data/mock';

const iconMap = {
  Users: Users,
  UserCheck: UserCheck,
  Database: Database,
  Smartphone: Smartphone,
  Ship: Ship,
  Building: Building
};

const Services = () => {
  return (
    <section id="services" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-teal-600 font-semibold text-sm uppercase tracking-wider">What We Offer</span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-800 mt-3 mb-6">
            Our Service Offerings
          </h2>
          <p className="text-slate-600 text-lg max-w-2xl mx-auto">
            Comprehensive IT solutions tailored to meet your business needs with excellence and precision.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="group relative bg-white rounded-2xl overflow-hidden shadow-sm border border-slate-100 hover:shadow-xl transition-all duration-500 hover:-translate-y-1"
              >
                {/* Image Section */}
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-slate-900/20 to-transparent"></div>
                  
                  {/* Card Number */}
                  <div className="absolute top-4 right-4 text-5xl font-bold text-white/20">
                    0{index + 1}
                  </div>
                  
                  {/* Icon Badge */}
                  <div className="absolute bottom-4 left-4 w-12 h-12 bg-teal-500 rounded-xl flex items-center justify-center shadow-lg">
                    <IconComponent className="w-6 h-6 text-white" />
                  </div>
                </div>

                {/* Content Section */}
                <div className="p-6">
                  <h3 className="text-xl font-bold text-slate-800 mb-3 group-hover:text-teal-600 transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed text-sm mb-4">
                    {service.description}
                  </p>

                  {/* Learn More Link */}
                  <div className="flex items-center gap-2 text-teal-600 font-medium text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300 cursor-pointer">
                    <span>Learn More</span>
                    <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
